<template>
  <div class="loadingText" v-if="loadingText">Loading...</div>
  <div v-else class="grid">
    <div class="unit-header">
      <div
        :class="[
          'unit-option',
          {
            selected: dataItem === selectedUnitType,
          },
        ]"
        v-for="dataItem in unitType"
        @click="setUnitType(dataItem)"
        :key="dataItem"
        :value="dataItem"
      >
        {{ dataItem }}
      </div>
    </div>

    <SKBox marginBottom="none" class="grid__item--full">
      <div class="header">
        <SKAlert marginBottom="0" class="header-alert">
          <div>Sentiance: {{ data.userId }}</div>
          <div>
            External: {{ data.externalUserId ? data.externalUserId : 'NA' }}
          </div>
        </SKAlert>
        <div class="header-info">
          <ul>
            <li v-for="(value, index) in summaryList()" :key="index">
              {{ value }}
            </li>
          </ul>
        </div>
      </div>
    </SKBox>
    <!-- Crash Report -->
    <SKBox marginBottom="none" title="Impact Time & Location">
      <SKInfoPanelItem
        v-if="timestamp"
        :title="date"
        text="Time of impact"
        icon="far fa-clock"
      />
      <SKInfoPanelItem
        :title="impactLocation"
        text="Location"
        icon="fas fa-map-marker-alt"
      />
      <div class="map-impact-view" id="map-impact"></div>
    </SKBox>

    <SKBox
      class="alert-box-class"
      marginBottom="none"
      title="Speed & acceleration Info"
    >
      <Highlights
        :mode="setSpeedHighlight(data).mode"
        :description="setSpeedHighlight(data).text"
      />
      <div class="div-box-view">
        <div class="sub-view">
          <SKInfoPanelItem :title="speedAtImpact" text="Speed at impact" />
        </div>
        <div class="line-view" />
        <div class="sub-view">
          <SKInfoPanelItem :title="deltaV" text="Delta-V" />
        </div>
      </div>
      <div class="div-box-view">
        <div class="sub-view">
          <SKInfoPanelItem :title="maxMagnitude" text="Max magnitude" />
        </div>
        <div class="line-view" />
        <div class="sub-view">
          <SKInfoPanelItem :title="confidence" text="Confidence" />
        </div>
      </div>
      <div id="bottom-text" class="box-bottom-link" align="center">
        Go to sensor pod
      </div>
    </SKBox>

    <SKBox class="alert-box-class" marginBottom="none" title="Driving Events">
      <Highlights
        :mode="drivingEventsHighlights.mode"
        :description="drivingEventsHighlights.text"
      />
      <div class="div-box-view">
        <div class="sub-view">
          <SKInfoPanelItem
            :title="phoneHandlingSeconds"
            text="Phone Handling"
          />
        </div>
        <div class="line-view" />
        <div class="sub-view">
          <SKInfoPanelItem
            :title="hardAccelerationTimes"
            text="Hard Accelaration"
          />
        </div>
      </div>
      <div class="div-box-view">
        <div class="sub-view">
          <SKInfoPanelItem :title="hardBrakingTimes" text="Hard Braking" />
        </div>
        <div class="line-view" />
        <div class="sub-view">
          <SKInfoPanelItem :title="speedingDistance" text="Speeding Distance" />
        </div>
      </div>
      <div id="bottom-text" class="box-bottom-link" align="center">
        Go to map
      </div>
    </SKBox>

    <SKBox marginBottom="none" class="impact-box-view" title="Impact direction">
      <SKAlert padding="8" class="feature-available-soon"
        >This feature will be available soon...</SKAlert
      >
    </SKBox>

    <SKBox marginBottom="none" title="Road type">
      <Highlights
        :mode="setRoadHighlightText(data).mode"
        :description="setRoadHighlightText(data).text"
      />
      <div class="div-box-view">
        <div class="sub-view" align="left">
          <SKInfoPanelItem :title="roadType" text="Type of road" />
        </div>
        <div class="sub-view" align="left">
          <SKInfoPanelItem :title="speedLimit" text="Speed limit" />
        </div>
      </div>
      <img
        class="bottom-view-image"
        :src="require('./assets/road.png')"
        alt="image description"
      />
    </SKBox>

    <SKBox marginBottom="none" title="Traffic conditions">
      <Highlights
        :mode="trafficHighlightText.mode"
        :description="trafficHighlightText.text"
      />
      <div class="traffic-view" align="left">
        <div class="grid-traffic">
          <div
            align="left"
            v-for="(item, index) in trafficIncidentData"
            :key="index"
          >
            <div>
              <SKInfoPanelItem
                :title="item.description"
                :text="item.fromRoad ? item.fromRoad : 'na'"
              />
            </div>
          </div>
        </div>
      </div>
    </SKBox>

    <SKBox marginBottom="none" title="Weather">
      <Highlights
        :mode="weatherHighlightText.mode"
        :description="weatherHighlightText.text"
      />
      <div class="div-box-view">
        <div class="sub-view" align="left">
          <SKInfoPanelItem :title="temperature" text="Temperature" />
        </div>
        <div class="line-view" />
        <div class="sub-view" align="left">
          <SKInfoPanelItem :title="precipitation" text="Precipitation" />
        </div>
      </div>
      <div class="div-box-view">
        <div class="sub-view" align="left">
          <SKInfoPanelItem :title="humidity" text="Humidity" />
        </div>
        <div class="line-view" />
        <div class="sub-view" align="left">
          <SKInfoPanelItem :title="visibility" text="Visibility" />
        </div>
      </div>
    </SKBox>

    <SKBox marginBottom="none" class="user-timeline-view" title="User Timeline">
      <SKAlert padding="8" class="feature-available-soon"
        >This feature will be available soon...</SKAlert
      >
    </SKBox>

    <SKBox marginBottom="none" class="grid__item--full">
      <div class="map-header-text-view">
        <h4 class="map-header-text">Map info</h4>
        <div align="right">
          <div class="map-view-class">
            <div class="map-header">
              <div
                class="map-loop-view"
                v-for="(item, index) in itemMaps"
                :key="index"
              >
                <div class="map-header-view">
                  <img
                    v-if="item.image"
                    class="image"
                    :src="require(`./assets/${item.image}`)"
                  />
                  <div>{{ item.text }}</div>
                  <input
                    type="checkbox"
                    v-model="item.selected"
                    id="selected"
                    class="form-check-input"
                    @change="check(item.text, item.selected)"
                    :load="loadMap(item.text, item.selected)"
                  />
                </div>
                <div class="line-view-map" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper-map-info">
        <div v-if="averageSpeed" class="speed-text-box">
          <div class="speed">
            Speed:-
            <a class="speed-text"> {{ currentSpeed.toFixed(1) }} kmph</a>
          </div>
          <div>
            Average Speed:-
            <a class="speed-text"> {{ averageSpeed.toFixed(1) }} kmph</a>
          </div>
        </div>
        <div class="map-view" id="google-map"></div>
      </div>
      <div
        v-if="
          accelaration && accelaration.length > 0 && speed && speed.length > 0
        "
      >
        <div class="chart-header-text-view">
          <h4 class="map-header-text">Acceration and Speed info</h4>
          <div align="right" class="chart-class-view">
            <div align="right" class="chart-class">
              <div class="chart-lable">
                <div class="lable-accelaration" />
                <div>Accelaration</div>
              </div>
              <div class="chart-lable">
                <div class="lable-speeding" />
                <div class="text-speeding">Speeding</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <chart
            ref="input"
            :accelarationData="accelaration"
            :speedData="speed"
            class="chart"
            :offset="data.crashEvent.timezoneOffset"
          ></chart>
        </div>
      </div>
    </SKBox>
  </div>
</template>
<script src="https://unpkg.com/@turf/turf@6/turf.min.js"></script>

<script>
import {
  SKBox,
  SKInfoPanelItem,
  SKAlert,
  getAccessToken,
} from 'sentiance.commons.sentikit';
import Chart from './SpeedChart.vue';
import { getCrashTransport } from './helpers/crash-transport';
import { getSummaryText } from './helpers/summary-text';
import {
  getStartEndPoints,
  getSpeedingLineStrings,
  getTrafficLineStrings,
  getStrokeColor,
} from './helpers/map';
import pako from 'pako';
import Highlights from './Highlights.vue';
import { getHighlightText } from './helpers/highlight-text';
import moment from 'moment-timezone';
import { getSpeedData, getAccelarationData } from './helpers/chart-timestamp';
import { getDataUnit } from './helpers/unit';
import { guessTimezoneFromOffset } from './helpers/timezone';
import { color } from './constants/color';
import {
  getHardAccelerationTime,
  gethardBrakingTimes,
} from './helpers/alert-box-text';
export default {
  name: 'CrashReport',
  components: { SKBox, SKInfoPanelItem, SKAlert, Chart, Highlights },
  props: {
    msg: String,
  },
  data: function () {
    return {
      data: {},
      crashTransport: {},
      itemMaps: [
        {
          image: 'break.png',
          text: 'Braking',
          selected: false,
        },
        {
          image: 'acceleration.png',
          text: 'Acceleration',
          selected: false,
        },
        {
          image: 'speeding.png',
          text: 'Speeding',
          selected: true,
        },
        {
          image: 'phone-handling.png',
          text: 'Phone handling',
          selected: false,
        },
        {
          text: 'Show all',
          selected: false,
        },
        {
          text: 'Traffic',
          selected: true,
        },
      ],
      accountId: '',
      appId: '',
      reportId: '',
      loading: true,
      weatherData: [],
      date: '',
      speed: [],
      accelaration: [],
      phoneHandlingSeconds: 0,
      drivingEventsHighlights: {},
      trafficHighlightText: {},
      weatherHighlightText: {},
      unitType: ['Metric', 'Imperial'],
      unitData: {},
      selectedUnitType: '',
      hardAccelerationTimes: '',
      hardBrakingTimes: '',
      mapEvent: '',
      dataPath: [],
      speedingLineMap: null,
      speedPolylines: [],
      offset: 0,
      guessedTimezone: 'UTC',
      trafficPolylines: [],
      trafficPath: [],
      mapEventTraffic: '',
      timestamp: '',
      speedAtImpact: '',
      deltaV: '',
      maxMagnitude: '',
      confidence: '',
      speedingDistance: '',
      roadType: '',
      speedLimit: '',
      trafficIncidentData: '',
      temperature: '',
      precipitation: '',
      visibility: '',
      humidity: '',
      routePolylines: [],
      averageSpeed: '',
      currentSpeed: '',
      loadingText: false,
      loadMapEventTraffic: false,
      impactLocation: '',
    };
  },

  watch: {
    mapEventTraffic: {
      handler: function () {
        if (this.loadMapEventTraffic) {
          this.createSpeedingPath(this.dataPath, this.speedingLineMap);
          this.createTrafficPath(this.trafficPath, this.speedingLineMap);
          this.createRoutePath(this.speedingLineMap);
        }
      },
    },
    mapEvent: {
      handler: function (e) {
        this.createSpeedingPath(this.dataPath, this.speedingLineMap);
      },
    },
  },

  mounted() {
    this.loadingText = true;
    this.accountId = this.$route.params.account_id;
    this.appId = this.$route.params.app_id;
    this.reportId = this.$route.params.report_id;
    this.loading = true;
    this.$api
      .get(
        `accounts/${this.accountId}/apps/${this.appId}/crash_reports/${this.reportId}`,
        { responseType: 'arraybuffer' }
      )
      .then(async (response) => {
        this.data = await this.gunzip(response);
        console.log('Data....', this.data);
        this.loadingText = false;
        this.crashTransport = await getCrashTransport(this.data);
        this.crashTransport && this.createGoogleMap();
        this.loadMapEventTraffic = true;
        this.speed = getSpeedData(this.crashTransport);
        this.accelaration = getAccelarationData(this.data);
        this.weatherData = this.data.weatherData;
        this.offset = this.data.crashEvent.timezoneOffset;
        this.guessedTimezone = guessTimezoneFromOffset(this.offset);
        this.timestamp = this.data.crashEvent.timestamp;
        this.impactLocation =
          this.getCrashImpactPoint() &&
          `Lat: ${this.getCrashImpactPoint().lat.toFixed(
            5
          )}, Lng: ${this.getCrashImpactPoint().lng.toFixed(5)}`;
        this.date =
          moment
            .utc(this.timestamp)
            .utcOffset(this.data.crashEvent.timezoneOffset)
            .format('ddd, DD MMM YYYY, HH:mm Z') + ' GMT';

        this.phoneHandlingSeconds = this.getPhoneHandling(this.data);
        this.hardAccelerationTimes = getHardAccelerationTime(this.data);
        this.hardBrakingTimes = gethardBrakingTimes(this.data);

        this.loading = false;
        if (localStorage.selectedUnitType) {
          this.setUnitType(localStorage.selectedUnitType);
        } else {
          this.setUnitType('Metric');
        }

        // this sets the default "moment" timezone
        // chartjs uses this timezone to convert/format the time in it's chart
        moment.tz.setDefault(this.guessedTimezone);

        this.createImpactMap();
        this.drivingEventsHighlights = getHighlightText(
          this.summaryText().drivingEvents,
          this.data
        ).drivingEventsHighlights;
        this.trafficHighlightText = getHighlightText(
          this.summaryText().traffic,
          this.data
        ).trafficConditionsHighlightText;
        this.weatherHighlightText = getHighlightText(
          this.summaryText().weather,
          this.data
        ).weatherHighlightText;
        this.maxMagnitude = this.data.crashEvent.maxMagnitude
          ? this.data.crashEvent.maxMagnitude.toFixed(1) + ' g'
          : 'na';
        this.confidence = this.data.crashEvent.confidence
          ? this.data.crashEvent.confidence.toString() + ' %'
          : 'na';
        this.roadType = this.data.crashEvent.roadType
          ? this.data.crashEvent.roadType
          : 'na';
        this.humidity =
          this.data && this.weatherData[this.weatherData.length - 1].humidity
            ? (
                this.weatherData[this.weatherData.length - 1].humidity * 100
              ).toFixed(1) + ' %'
            : 'na';

        this.trafficIncidentData =
          this.data &&
          this.data.trafficIncidentData &&
          this.data.trafficIncidentData.length > 0 &&
          this.data.trafficIncidentData[0].trafficIncidents;
        return this.data;
      });
  },

  methods: {
    async getToken() {
      return await getAccessToken();
    },
    resetZoom() {
      this.$refs.input.resetZoom();
    },
    setUnitType(unitType) {
      this.selectedUnitType = unitType;
      localStorage.setItem('selectedUnitType', unitType);
      this.unitData = getDataUnit(this.data);
      this.unitData &&
        ((this.speedAtImpact = this.unitData.speedAtImpact),
        (this.deltaV = this.unitData.deltaV),
        (this.speedingDistance = this.unitData.speedingDistance),
        (this.speedLimit = this.unitData.speedLimit),
        (this.temperature = this.unitData.temperature),
        (this.precipitation = this.unitData.precipitation),
        (this.visibility = this.unitData.visibility));
    },

    getPhoneHandling(data) {
      if (
        data.phoneHandlingSeconds !== null &&
        !isNaN(data.phoneHandlingSeconds)
      ) {
        if (data.phoneHandlingSeconds < 60) {
          return `00m ${data.phoneHandlingSeconds} s`;
        } else {
          return `${Math.floor(data.phoneHandlingSeconds / 60)} m ${
            data.phoneHandlingSeconds % 60
          } s`;
        }
      } else {
        return 'na';
      }
    },

    check(event, selected) {
      if (event === 'Speeding' && selected === true) {
        this.mapEvent = event;
      } else if (event === 'Traffic' && selected === true) {
        this.mapEventTraffic = event;
      } else {
        this.mapEvent = '';
        this.mapEventTraffic = '';
      }
    },

    loadMap(event, selected) {
      if (event === 'Speeding' && selected === true) {
        this.mapEvent = event;
      } else if (event === 'Traffic' && selected === true) {
        this.mapEventTraffic = event;
      } else {
        return;
      }
    },

    setRoadHighlightText(data) {
      return getHighlightText(this.summaryText().road, data).roadHighlightText;
    },

    setSpeedHighlight(data) {
      return getHighlightText(this.summaryText().speed, data).speedHighlight;
    },

    gunzip(buffer) {
      return new Promise((resolve, reject) => {
        try {
          var deserialized = JSON.parse(
            pako.inflate(buffer.body, { to: 'string' })
          );
          resolve(deserialized);
        } catch (err) {
          reject(err);
        }
      });
    },

    summaryText() {
      return getSummaryText(this.data);
    },
    summaryList() {
      let summaryList = [];
      const summaryMap = getSummaryText(this.data);

      for (const key in summaryMap) {
        const value = summaryMap[key];
        if (!value) continue;

        summaryList.push(value);
      }

      return summaryList;
    },
    coordinates() {
      const lineString =
        this.crashTransport &&
        this.crashTransport.timelineEvent &&
        this.crashTransport.timelineEvent.trajectory &&
        this.crashTransport.timelineEvent.trajectory.map((p, i) => ({
          lng: p.location.longitude,
          lat: p.location.latitude,
          speed: p && p.speedV2,
          averageSpeed:
            i > 0
              ? (this.crashTransport.timelineEvent.trajectory[i].speedV2 +
                  this.crashTransport.timelineEvent.trajectory[i - 1].speedV2) /
                2
              : null,
        }));

      return lineString;
    },

    async createImpactMap() {
      const map = new google.maps.Map(document.getElementById('map-impact'), {
        center: this.getCrashImpactPoint(),
        zoom: 15,
      });
      this.googleMap = map;

      // Show the crash impact area view
      new google.maps.Circle({
        strokeColor: '#1E90FF',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1E90FF',
        fillOpacity: 0.35,
        map,
        center: this.getCrashImpactPoint(),
        radius: 100,
      });
    },

    // TODO: Return the center based on the bounds of the route
    getCrashImpactPoint() {
      return {
        lat:
          this.data.crashEvent &&
          this.data.crashEvent.waypoint &&
          this.data.crashEvent.waypoint.location.latitude,
        lng:
          this.data.crashEvent &&
          this.data.crashEvent.waypoint &&
          this.data.crashEvent.waypoint.location.longitude,
      };
    },

    createSpeedingPath(dataPath, map) {
      dataPath.map((path) => {
        let routeSpeedingPath = new google.maps.Polyline({
          path: path,
          geodesic: true,
          strokeColor: color.red,
          strokeOpacity: 1.0,
          strokeWeight: 4,
        });
        routeSpeedingPath.setMap(map);

        this.speedPolylines.push(routeSpeedingPath);
        if (
          this.mapEvent !== 'Speeding' ||
          this.mapEventTraffic === 'Traffic'
        ) {
          this.speedPolylines.map((poly) => {
            poly.setVisible(false);
          });
        } else {
          this.speedPolylines.map((poly, i) => {
            poly.setVisible(true);
            this.showSpeedData(poly, path, i);
          });
        }
      });
    },
    createTrafficPath(dataPath, map) {
      dataPath.map((path) => {
        let routeTrafficPath = new google.maps.Polyline({
          path: path.path,
          geodesic: true,
          strokeColor: getStrokeColor(path.type),
          strokeOpacity: 1.0,
          strokeWeight: 4,
        });
        routeTrafficPath.setMap(map);

        this.trafficPolylines.push(routeTrafficPath);

        if (this.mapEventTraffic !== 'Traffic') {
          this.trafficPolylines.map((poly) => {
            poly.setVisible(false);
          });
        } else {
          this.trafficPolylines.map((poly) => {
            poly.setVisible(true);
            google.maps.event.addListener(poly, 'mouseover', () => {
              this.averageSpeed = path.averageSpeed;
              this.currentSpeed = path.speed;
            });
          });
        }
      });
    },

    createRoutePath(map) {
      let routePath;
      routePath = new google.maps.Polyline({
        path: this.coordinates(),
        geodesic: true,
        strokeOpacity: 1.0,
        strokeWeight: 4,
      });

      this.routePolylines.push(routePath);
      if (this.mapEventTraffic !== 'Traffic') {
        this.routePolylines.map((poly, i) => {
          poly.setOptions({
            strokeColor: color.green,
          });
          this.showSpeedData(poly, this.coordinates(), i);
        });
      } else {
        this.routePolylines.map((poly, i) => {
          poly.setOptions({
            strokeColor: color.default,
          });
          this.showSpeedData(poly, this.coordinates(), i);
        });
      }
      routePath.setMap(map);
    },

    showSpeedData(poly, path, i) {
      google.maps.event.addListener(poly, 'mouseover', () => {
        this.currentSpeed = path[i].speed;
        this.averageSpeed =
          this.coordinates &&
          this.coordinates()[i - 1] &&
          (this.coordinates()[i - 1].averageSpeed +
            this.coordinates()[i].averageSpeed) /
            2;
      });
    },

    createGoogleMap() {
      const points = getStartEndPoints(this.crashTransport);

      const map = new google.maps.Map(document.getElementById('google-map'), {
        center: this.getCrashImpactPoint(),
        zoom: 15,
        streetViewControl: true,
        disableDefaultUI: true,
      });

      this.googleMap = map;

      this.dataPath = getSpeedingLineStrings(
        this.crashTransport.timelineEvent.trajectory
      );
      this.trafficPath = getTrafficLineStrings(this.data.trafficFlow);

      this.speedingLineMap = map;
      this.createRoutePath(this.speedingLineMap);

      this.createSpeedingPath(this.dataPath, this.speedingLineMap);
      this.createTrafficPath(this.trafficPath, this.speedingLineMap);

      // Set up the markers on the map
      new google.maps.Marker({
        position: points.start,
        map,
        icon: require('./assets/map-marker.png'),
      });

      new google.maps.Marker({
        position: points.end,
        map,
        icon: require('./assets/map-marker.png'),
      });

      new google.maps.Marker({
        position: points.car,
        map,
        icon: require('./assets/map-car.png'),
      });

      new google.maps.Marker({
        position: {
          lat:
            this.data.crashEvent &&
            this.data.crashEvent.waypoint &&
            this.data.crashEvent.waypoint.location.latitude,
          lng:
            this.data.crashEvent &&
            this.data.crashEvent.waypoint &&
            this.data.crashEvent.waypoint.location.longitude,
        },
        map,
        icon: require('./assets/crash-icon.png'),
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import './css/crash-report.css';
</style>
